import * as actionTypes from "../action-types";

const initialState = {
    isLoading: false,
    isSidebarOpen: true,

    //* Description Modal
    descriptionModalData: null,
    descriptionModalIsOpen: false,
};

const commonReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_IS_LOADING:
            return { ...state, isLoading: payload, };

        case actionTypes.SET_IS_SIDEBAR_OPEN:
            return { ...state, isSidebarOpen: payload, };

        //* Description Modal
        case actionTypes.OPEN_DESCRIPTION_MODAL:
            return { ...state, descriptionModalIsOpen: true, descriptionModalData: payload };

        case actionTypes.CLOSE_DESCRIPTION_MODAL:
            return { ...state, descriptionModalIsOpen: false, descriptionModalData: null };

        default:
            return state;
    }
};

export default commonReducer;